import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import NCZIWizard from './NCZIWizard';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

const NCZIWizardModal: React.FC<Props> = ({ isOpen, onClose }) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.LG}>
			<Modal.Header title='nczi.wizardModal.title' />
			<Modal.Content>
				<NCZIWizard onFinish={onClose} />
			</Modal.Content>
		</Modal>
	);
};

export default NCZIWizardModal;
